import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { ToCurrency } from "../../../utils";

class SubPricingOverview extends PureComponent {
  render() {
    const { titleKey, value, currency, className = "" } = this.props;
    return (
      <div key={titleKey} className={`${className} nw-pricing-unit`}>
        <span>{titleKey}</span>
        <span>{ToCurrency(value, currency)}</span>
      </div>
    );
  }
}

SubPricingOverview.propTypes = {
  key: PropTypes.string.isRequired,
  titleKey: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  currency: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: SubPricingOverview,
  component: SubPricingOverview,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/component/PricingOverview/SubPricing/index.js